import MyProducts from './MyProducts';

function MyCoursesList() { 
    return (
        <>
            <MyProducts forpage="courses" section="courses" />
        </>
    );
}

export default MyCoursesList;
